module.exports = __webpack_public_path__ + "static/media/meteor-dribbble-1.74c617fc.jpg";